import { useAuth } from "@/contexts/AuthContext";
import { isPlatformAdmin } from "@/utils/platformAdmin";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

type PlatformAdminRouteProps = {
  children: React.ReactNode;
};

export function PlatformAdminRoute({ children }: PlatformAdminRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isPlatformAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
